import Spoiler from './spoiler';

export default Spoiler;
